<div class="input-container p-col-12">
  <div class="input-cell">
    <label *ngIf="label">{{ label }}</label>
    <span class="input-flex flex-right">
      <p-autoComplete
        [disabled]="disabled"
        [ngModelOptions]="{ standalone: true }"
        [(ngModel)]="item"
        [suggestions]="filteredItems"
        placeholder="Type to search a Community"
        field="normalizedName"
        (completeMethod)="filter($event)"
        (onSelect)="onSelect($event)"
        styleClass="autocomplete-tile complete-input"
        inputStyleClass="complete-input"
      >
        <ng-template let-item pTemplate="item">
          <community-tile [data]="item" hoverActive="1"></community-tile>
        </ng-template>
      </p-autoComplete>
    </span>
  </div>
</div>
